export const barChartOptions = {
  animation: { startup: true, duration: 1000, easing: 'out' },
  focusTarget: 'category',
  legend: { position: 'none' },
  isStacked: true,
  bar: { groupWidth: '85%' },
  width: '100%',
  height: '130px',
};
